import React, { Suspense } from "react";
// Handle console logs
import "utils/dropConsole";
// Styles
import "fontsource-roboto";
// ROUTER
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.css";
// Redux
import { Provider } from "react-redux";
import store from "./Store/index";

import MainContainer from "./pages/MainContainer";

import BackdropComponent from "components/Spinner/Spinner";
import { AuthProvider } from "context/AuthContext";

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <AuthProvider>
        <MainContainer />
      </AuthProvider>
    ),
  },
]);

function App() {
  return (
    <Suspense fallback={<BackdropComponent />}>
      <div>
        <Provider store={store}>
          <RouterProvider router={router} />
        </Provider>
      </div>
    </Suspense>
  );
}

export default App;
